/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from 'lodash';
import { i18n } from '../../../translate/i18n';
import { toastr } from 'react-redux-toastr';
import { selectUrl } from '../../../axios/baseUrl';
import api from '../../../axios/api';
import {
  Paper, Container, Button, Drawer, Table, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, Avatar, Chip, Checkbox, Dialog,
} from '@mui/material';
import { FilterList } from '@mui/icons-material';
import * as actions from "../../../store/actions";
import Spinner from '../../../components/Spinner/index';
import EquipmentModalFilter from '../ModalFilter/Equipments/index';

import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import EquipmamentChangeStatusInput from '../../../components/EquipmentChangeStatusInput/index';
import confirm from "../../../UI/Confirm/confirm";
import { renderStatusIcon, renderStatusColor } from '../../../utils/statusManipulation';
import { formatLanguageFromLocalStorage } from '../../../utils/formatLanguageFromLocalStorage';
import { ModalMassService } from "../Modals/ModalMassService";
import { EquipmentsRegistrationLimitWarning } from "../../../components/EquipmentsRegistrationLimitWarning";
import { EAccessRole } from "../../../store/types";
import { EDataExportsType } from "../../../store/reducers/dataExports";
import EFeatureFlags from "../../../utils/EFeatureFlags";

export default function TableManagementEquips(props) {
  const dispatch = useDispatch();
  const textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [limit, setLimit] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("place");
  const [order, setOrder] = useState("asc");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [printQRCodeLoading, setPrintQRCodeLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedEquipmentsObj, setSelectedEquipmentsObj] = useState([]);

	const [activeComment, setActiveComment] = useState('');
  const [showActiveCommentInput, setShowActiveCommentInput] = useState(false);

  const [maintenanceReason, setMaintenanceReason] = useState('');
  const [showMaintenanceReasonInput, setShowMaintenanceReasonInput] = useState(false);

  const [sendMaintenance, setSendMaintenance] = useState(null);
  const [sendForInactivate, setSendForInactivate] = useState(null);

  const [modalMassService, setModalMassService] = useState(false);
  
  const equipmentsToSendToMaintenance = selectedEquipmentsObj.filter(item => (item.statusGlobal !== 'maintenance' && item.statusGlobal !== 'inactive'))
  const equipmentsToSendToMaintenanceIds = equipmentsToSendToMaintenance.map(item => item._id)
  
  const equipmentsToReturnFromMaintenance = selectedEquipmentsObj.filter(item => (item.statusGlobal === 'maintenance'))
  const equipmentsToReturnFromMaintenanceIds = equipmentsToReturnFromMaintenance.map(item => item._id)

  const equipmentsToInactivate = selectedEquipmentsObj.filter(item => (item.statusGlobal !== 'inactive'))
  const equipmentsToInactivateIds = equipmentsToInactivate.map(item => item._id);

  const equipmentsToReactivate = selectedEquipmentsObj.filter(item => (item.statusGlobal === "inactive"))
  const equipmentsToReactivateIds = equipmentsToReactivate.map(item => item._id);
  
  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  // Modal Filter
  const filteredPlaces = useSelector(state => state.equipments.filters.filteredPlaces);
  const filteredModels = useSelector(state => state.equipments.filters.filteredModels);
  const filteredGroups = useSelector(state => state.equipments.filters.filteredGroups);
  const filteredAreas = useSelector(state => state.equipments.filters.filteredAreas);
  const filteredCompanies = useSelector(state => state.equipments.filters.filteredCompanies);
  const filteredStatus = useSelector(state => state.equipments.filters.filteredStatus);
  const filterDeletedEquipments = useSelector(state => state.equipments.filters.filterDeletedEquipments);

  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const isAnalyst = selectedAccess.role === EAccessRole.analyst;
  const isContractor = selectedAccess.role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);
  const onlyQRServicesFeatureFlag = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING);
  const blockQrCodePrinting = (onlyQRServicesFeatureFlag && (isAnalyst || isContractor));

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const fetchEquipments = useCallback(
    () => dispatch(actions.fetchEquipments(page, limit, searchText, order, orderBy, selectedSites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, filterDeletedEquipments)),
    [page, limit, searchText, order, orderBy, selectedSites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, filterDeletedEquipments]
  );

  const fetchEquipmentsExport = useCallback(
    () => dispatch(actions.fetchEquipmentsExport(searchText, order, orderBy, selectedSites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage)),
    [searchText, order, orderBy, selectedSites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage]
  );

  const fetchEquipmentServicesReplicatedDataExport = useCallback(
    () => dispatch(actions.fetchEquipmentServicesReplicatedDataExport(selectedEquipmentsObj.map(item => item._id), EDataExportsType.equipmentReplicatedServicesWithAttachmentsReport, emailLanguage)),
    [selectedEquipmentsObj]
  );

  const equipments = useSelector(state => state.equipments.equipments);
  const equipmentsFilter = useSelector(state => state.equipments.equipmentsFilter);
  const loading = useSelector(state => state.equipments.loading);

  const headRows = [
    { id: "equipmentModel.name", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.equipmentModelName') },
    { id: "equipmentModel.equipmentGroup.name", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.equipmentGroupName') },
    { id: "place.path", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.placeName') },
    { id: "company.name", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.company') },
    { id: "reference", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.referenceName') },
    { id: "description", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.description') },
    { id: "createdAt", numeric: false, disablePadding: false, label: i18n.t('headRowsManagementEquip.createdAt') },
  ];

  useEffect(() => {
    if (!isEmpty(equipmentsFilter)) {
      setPage(equipmentsFilter.page);
      setLimit(equipmentsFilter.limit);
      setSearchText(equipmentsFilter.searchText);
      setOrderBy(equipmentsFilter.orderBy);
      setOrder(equipmentsFilter.order);
    }
    setFirstLoad(false);
  }, []);

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])

  useEffect(() => {
    if (!firstLoad) {
      fetchEquipments();
      setAlreadySerched(true);
    }
  }, [firstLoad, page, limit, order, orderBy]);

  useEffect(() => {
    if (!firstLoad) {
      setPage(1);
      fetchEquipments();
      setAlreadySerched(true);
    }
  }, [selectedSites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, filterDeletedEquipments]);

  useEffect(() => {
    if (searchText !== "" || alreadySerched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchEquipments();
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
    handleEmptySelected();
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
    handleEmptySelected();
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
    handleEmptySelected();
  };

  const selectRow = (e, id) => {
    props.history.push(`/form-equip/${id}/admin-gestao-equip`)
  }

  const deleteFilteredSite = (site) => {
    dispatch(actions.deleteFilteredSite(site))
  }

  const deleteFilteredPlaces = (place) => {
    dispatch(actions.filterEquipmentPlacesRemove(place))
  }

  const deleteFilteredGroups = (group) => {
    dispatch(actions.filterEquipmentGroupsRemove(group))
  }

  const deleteFilteredAreas = (group) => {
    dispatch(actions.filterEquipmentAreasRemove(group))
  }

  const deleteFilteredCompanies = (company) => {
    dispatch(actions.filterEquipmentCompaniesRemove(company))
  }

  const deleteFilteredModels = (model) => {
    dispatch(actions.filterEquipmentModelsRemove(model))
  }

  const deleteFilteredDeletedEquipments = (equipment) => {
    dispatch(actions.filterDeletedEquipmentsRemove(equipment))
  }

  const deleteFilteredStatus = (key) => {
		if (key.includes('invalid.')) {
			const invalidKey = key.split('.')[1];
			dispatch(actions.filterEquipmentStatus({ ...filteredStatus, invalid: { ...filteredStatus.invalid, [invalidKey]: false } }));
		} else {
			dispatch(actions.filterEquipmentStatus({ ...filteredStatus, [key]: false }));
		}
	};

  const clearFilterButton = () => {
    if ((filteredGroups && filteredGroups.length > 0)
      || (filteredPlaces && filteredPlaces.length > 0)
      || (filteredModels && filteredModels.length > 0)
      || (filteredCompanies && filteredCompanies.length > 0)
      || (filteredAreas && filteredAreas.length > 0))
      return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('clearFilterButtonManagementEquip.Typography')}</Typography>;
  };

  const renderSitesChips = () => (selectedSites && selectedSites.map((site) => (<Chip
    key={site._id}
    label={site.name}
    onDelete={() => deleteFilteredSite(site)}
    style={styles.filterChip} />)))
  const renderPlacesChips = () => (filteredPlaces && filteredPlaces.map((place) => (<Chip
    key={place.value}
    label={place.label}
    onDelete={() => deleteFilteredPlaces(place)}
    style={styles.filterChip} />)))
  const renderGroupsChips = () => (filteredGroups && filteredGroups.map((group) => (<Chip
    key={group.value}
    label={group.label}
    onDelete={() => deleteFilteredGroups(group)}
    style={styles.filterChip} />)))
  const renderAreasChips = () => (filteredAreas && filteredAreas.map((area) => (<Chip
    key={area.value}
    label={area.label}
    onDelete={() => deleteFilteredAreas(area)}
    style={styles.filterChip} />)))
  const renderModelsChips = () => (filteredModels && filteredModels.map((model) => (<Chip
    key={model.value}
    label={model.label}
    onDelete={() => deleteFilteredModels(model)}
    style={styles.filterChip} />)))
  const renderCompaniesChips = () => (filteredCompanies && filteredCompanies.map((company) => (<Chip
    key={company.value}
    label={company.label}
    onDelete={() => deleteFilteredCompanies(company)}
    style={styles.filterChip} />)))
  const renderStatusChips = () => {
    let chips = [];
    if (filteredStatus && filteredStatus.valid) chips.push(<Chip
      key="valid"
      label={i18n.t('statusOptions.valid')}
      onDelete={() => deleteFilteredStatus('valid')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.validWithOpenedActions) chips.push(<Chip
      key="validWithOpenedActions"
      label={i18n.t('statusOptions.validWithOpenedActions')}
      onDelete={() => deleteFilteredStatus('validWithOpenedActions')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.inactive) chips.push(<Chip
      key="inactive"
      label={i18n.t('statusOptions.inactive')}
      onDelete={() => deleteFilteredStatus('inactive')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.maintenance) chips.push(<Chip
      key="maintenance"
      label={i18n.t('statusOptions.maintenance')}
      onDelete={() => deleteFilteredStatus('maintenance')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.inDelay) chips.push(<Chip
      key="invalid.inDelay"
      label={i18n.t('statusOptions.inDelay')}
      onDelete={() => deleteFilteredStatus('invalid.inDelay')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.notDone) chips.push(<Chip
      key="invalid.notDone"
      label={i18n.t('statusOptions.notDone')}
      onDelete={() => deleteFilteredStatus('invalid.notDone')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.hasActionsOpenedOrOverdue) chips.push(<Chip
      key="invalid.hasActionsOpenedOrOverdue"
      label={i18n.t('statusOptions.hasActionsOpenedOrOverdue')}
      onDelete={() => deleteFilteredStatus('invalid.hasActionsOpenedOrOverdue')}
      style={styles.filterChip} />)
    if (filteredStatus && filteredStatus.invalid.hasNoServices) chips.push(<Chip
      key="hasNoServices"
      label={i18n.t('statusOptions.hasNoServices')}
      onDelete={() => deleteFilteredStatus('invalid.hasNoServices')}
      style={styles.filterChip} />)
    return chips;
  }
  const renderdeletedEquipmentsChips = () => (filterDeletedEquipments && <Chip
    key={filterDeletedEquipments}
    label={i18n.t('adminOptions.showDeletedChipLabel')}
    onDelete={() => deleteFilteredDeletedEquipments()}
    style={styles.filterChip} />)

  const handleClickClearFilters = useCallback(() => dispatch(actions.filterEquipmentClear()));

  const exportExcel = () => {
    setExportLoading(true);
    fetchEquipmentsExport()
      .then(response => {
        if (response) {
          window.open(response.url, "_blank")
        }
        setExportLoading(false);
      })
      .catch(() => setExportLoading(false))
  }

	const selectAll = () => {
    if (equipments.rows) {
      if (selected && selected.length !== equipments.rows.length) {
        const aux = equipments.rows.map(el => el._id);
        setSelected(aux);
      } else {
        setSelected([]);
      }

      if (selectedEquipmentsObj && selectedEquipmentsObj.length !== equipments.rows.length) {
        const bodysToSendForMaintenance = equipments.rows.map(el => el);

        setSelectedEquipmentsObj(bodysToSendForMaintenance)
      } else {
        setSelectedEquipmentsObj([])
      }
    }
  };

	const isItemSelected = (item) => {
    return selected && selected.indexOf(item) !== -1;
  };

	const handleEmptySelected = () => {
    setSelected([]);
    setSelectedEquipmentsObj([]);
  };

	const checkboxChange = (itemId, value, item) => {
    if (selected) {
      const aux = [...selected];
      if (selected.indexOf(itemId) === -1) {
        aux.push(itemId);
        setSelected(aux);
      } else {
        aux.splice(selected.indexOf(itemId), 1);
        setSelected(aux);
      }
    }

    if(selectedEquipmentsObj) {
      const aux = [...selectedEquipmentsObj];

      if(!aux.find(obj => obj._id === itemId)) {
        aux.push(item)
        setSelectedEquipmentsObj(aux);
      } else {
        const itemAlreadyExists = aux.find(obj => obj._id === itemId);
        const index = selectedEquipmentsObj.findIndex(obj => obj._id === itemAlreadyExists._id)
        aux.splice(index, 1);
        setSelectedEquipmentsObj(aux);
      }
    }
  };

	const handleSendForInactivate = () => {
		setSendForInactivate(true);
	}

  const handleSendForReactivate = () => {
		setSendForInactivate(false);
	}

	const handleCloseActiveComment = () => {
    setShowActiveCommentInput(false);
  }

  const handleClickMaintenanceEquipments = () => {
		setShowMaintenanceReasonInput(true);
	}

  const handleClickInactivateEquipments = () => {
		setShowActiveCommentInput(true);
	}

  const handleSendForMaintenance = () => {
		setSendMaintenance(true);
	}

  const handleReturnFromMaintenance = () => {
		setSendMaintenance(false);
	}

  const handleCloseMaintenanceReason = () => {
    setShowMaintenanceReasonInput(false);
  }

	const handleSaveActiveStatus = (ids, value) => {
		const body = {
			comment: activeComment,
			ids,
      sendForInactivate: value,
		}

		try {
			handleEmptySelected();
			setShowActiveCommentInput(false);

			dispatch(actions.inactivateEquipments(body))
		} catch(err) {
			setShowActiveCommentInput(false);
		}
	}

  const handleMaintenanceChange = (ids, value) => {
    const body = {
			comment: maintenanceReason,
			ids,
      sendForMaintenance: value,
		}

		try {
      handleEmptySelected();
			setShowMaintenanceReasonInput(false);

			dispatch(actions.maintenanceEquipments(body))
		} catch(err) {
			setShowMaintenanceReasonInput(false);
		}
	}

  const handleDeleteMultipleEquipments = () => {
    const body = {
			ids: selected
		}

    confirm(`${i18n.t('handleDeleteEquipment.confirm3')} \n ${i18n.t('handleDeleteEquipment.confirm2')}`,
      {
        title: `${i18n.t('handleDeleteEquipment.title2')} (${body.ids.length})`,
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
            handleEmptySelected();

            dispatch(actions.deleteMultipleEquipments(body))
            .then(result => {
              if (result === 'success') {
                fetchEquipments();
              }
            })
        },
      )
      .catch(err => {
        console.log(err.message)
      })
  }

  const handleClickPrintQRCodes = async () => {
    const url = `${selectUrl()}/equipments/printqrcodes`;
    const ids = selected;

    setPrintQRCodeLoading(true);
    try {
      toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
      const response = await api.post(url, { ids })
      if (response.status === 200) window.open(response.data.url);
    } catch (error) {
      toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
    }
    setPrintQRCodeLoading(false);
  }

  const addFromExcel = () => {
    confirm('A planilha modelo conterá apenas os locais existentes nos sites filtrados nesta página, caso não selecione nenhum filtro, todos os locais serão apresentados na tabela para você selecionar',
    {
      title: 'ATENÇÃO',
      titleColor: 'red',
      disableBackdrop: true
    }).then(
      () => {  },
      () => props.history.push('massive-import/equipment')
    )
  }

  return <>
    {showActiveCommentInput && sendForInactivate &&
      <EquipmamentChangeStatusInput
          setContent={setActiveComment}
          handleSave={() => handleSaveActiveStatus(equipmentsToInactivateIds, true)}
          closeModal={handleCloseActiveComment}
          title={`${i18n.t('changeStatusInputManagementEquip.title')} (${equipmentsToInactivateIds.length})`}
          type='inactivate'
      />
    }
    {showActiveCommentInput && !sendForInactivate &&
      <EquipmamentChangeStatusInput
          setContent={setActiveComment}
          handleSave={() => handleSaveActiveStatus(equipmentsToReactivateIds, false)}
          closeModal={handleCloseActiveComment}
          title={`${i18n.t('changeStatusInputManagementEquip.title2')} (${equipmentsToReactivateIds.length})`}
          type='inactivate'
      />
    }
    {showMaintenanceReasonInput && sendMaintenance &&
      <EquipmamentChangeStatusInput
        setContent={setMaintenanceReason}
        handleSave={() => handleMaintenanceChange(equipmentsToSendToMaintenanceIds, true)}
        closeModal={handleCloseMaintenanceReason}
        title={`${i18n.t('equipmentChangeStatusInput.maintenanceTitleFalse')} ${i18n.t('equipmentChangeStatusInput.maintenanceTitle')} (${equipmentsToSendToMaintenanceIds.length})`}
        type='maintenance'
      />
    }
    {showMaintenanceReasonInput && !sendMaintenance &&
      <EquipmamentChangeStatusInput
        setContent={setMaintenanceReason}
        handleSave={() => handleMaintenanceChange(equipmentsToReturnFromMaintenanceIds, false)}
        closeModal={handleCloseMaintenanceReason}
        title={`${i18n.t('equipmentChangeStatusInput.maintenanceTitleTrue')} ${i18n.t('equipmentChangeStatusInput.maintenanceTitle')}  (${equipmentsToReturnFromMaintenanceIds.length})`}
        type='maintenance'
      />
    }
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}>
      <EquipmentModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <Container maxWidth="xl">
      <EquipmentsRegistrationLimitWarning version="table" />
      <Paper>
        <TableTitle
          title={i18n.t('tableTitleManagementEquip.title')}
          placeholder={i18n.t('tableTitleManagementEquip.placeholder')}
          inputRef={textInput}
          value={searchText}
          onChange={event => {
            setPage(1);
            setSearchText(event.target.value);
          }}
          addRow={() => props.history.push(`/form-equip/new/admin-gestao-equip`)}
          addRowLabel={i18n.t('tableTitleManagementEquip.addRowLabel')}
          clickExport={exportExcel}
          downloading={exportLoading}
          exportButtonDisabled={loading}
          showOptionsButton
          inactivate={() => handleClickInactivateEquipments()}
          disableSendForInactivate={equipmentsToInactivateIds.length === 0 || isInspector}
          disableSendForReactivate={equipmentsToReactivateIds.length === 0 || isInspector}
          sendForInactivate={() => handleSendForInactivate()}
          sendForReactivate={() => handleSendForReactivate()}
          deleteMultipleEquipments={() => handleDeleteMultipleEquipments()}
          openModalMassService={() => setModalMassService(true)}
          disableDeleteMultipleEquipments={selected.length === 0 || isInspector}
          disableMakeServiceInMass={selectedEquipmentsObj.length === 0 || isInspector}
          printQRCodes={() => handleClickPrintQRCodes()}
          disablePrintQRCodes={selected.length === 0}
          blockPrintQRCodesForAnalystAndContractor={blockQrCodePrinting}
          sendForMaintenance={() => handleSendForMaintenance()}
          returnFromMaintenance={() => handleReturnFromMaintenance()}
          maintenanceEquipments={() => handleClickMaintenanceEquipments()}
          disableSendForMaintenanceButton={equipmentsToSendToMaintenanceIds.length === 0 || isInspector}
          disableReturnFromMaintenanceButton={equipmentsToReturnFromMaintenanceIds.length === 0 || isInspector}
          addFromExcel={() => addFromExcel()}
          selectedItemsCount={selected.length}
          hideAddButton={isInspector}
          helperTextSearch={i18n.t('tableTitleManagementEquip.helperTextSearch')}
          massServicesWithAttachmentsExport={() => fetchEquipmentServicesReplicatedDataExport()}
          disableMassServicesWithAttachmentsExport={selectedEquipmentsObj.length === 0}
        />
        <div style={styles.filterChipContainer}>
          <Button
            variant='contained'
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
          {i18n.t('btnFilterManagementEquip.label')}<FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderSitesChips()}
          {renderModelsChips()}
          {renderPlacesChips()}
          {renderGroupsChips()}
          {renderAreasChips()}
          {renderCompaniesChips()}
          {renderStatusChips()}
          {renderdeletedEquipmentsChips()}
          {clearFilterButton()}
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <div style={styles.spinner}>
                    <Spinner />
                  </div>}
                {equipments.rows.length === 0 &&
                  <div style={styles.noResults}>
                    {!loading && <Typography style={styles.spinner}>{i18n.t('btnFilterManagementEquip.Typography')}</Typography>}
                  </div>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={{ opacity: loading ? 0.3 : 1 }}
            headRows={headRows}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            checkbox
            onSelectAllClick={selectAll}
            numSelected={selected ? selected.length : 0}
            rowCount={equipments.rows ? equipments.rows.length : 0}
          />
          <TableBody style={{ opacity: loading ? 0.3 : 1 }}>
            {equipments.rows && equipments.rows.map((equip, index) => {
              return (
                <TableRow
                  style={styles.tableRow}
                  key={equip._id}
                  hover
                  onClick={event => selectRow(event, equip._id)}
                >
                                      <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                                          <Checkbox
                                              checked={isItemSelected(equip._id)}
                                              onChange={(e) => checkboxChange(equip._id, e.target.checked, equip)}
                      disabled={equip.statusGlobal === 'not defined'}
                                          />
                                      </TableCell>
                  <TableCell style={styles.cell}>
                    <div style={styles.cellPhotoContainer}>
                                              <div style={styles.status}>{renderStatusIcon(equip)}</div>
                      {equip.photo ?
                                                  <Avatar
                                                      src={equip.photo.url}
                                                      style={{
                                                          ...styles.avatar,
                                                          border: `2px solid ${renderStatusColor(equip)}`
                                                      }}
                                                  />
                                                  :
                                                  <Avatar
                                                      style={{
                                                          ...styles.avatarSmallText,
                                                          border: `2px solid ${renderStatusColor(equip)}`
                                                      }}
                                                  >
                                                      FOTO
                                                  </Avatar>
                                              }
                      <div style={styles.equipmentName}>
                        <div>{equip.equipmentModel.name}</div>
                        <div style={{ color: 'grey' }}>{equip.serialNumber}</div>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell style={styles.cell}>{equip.equipmentModel.equipmentGroup && equip.equipmentModel.equipmentGroup.name}</TableCell>
                  <TableCell style={styles.cell}>{equip.place && equip.place.path}</TableCell>
                  <TableCell style={styles.cell}>
                    {equip.companies.map((company) => (<Chip
                      key={company._id}
                      label={company.name}
                      style={styles.filterChip} />))
                    }
                  </TableCell>
                  <TableCell style={styles.cell}>{equip.reference}</TableCell>
                  <TableCell style={styles.cell}>{equip.description}</TableCell>
                  <TableCell style={styles.cell}>{new Date(equip.createdAt).toLocaleDateString('pt-BR')}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
          <TableFooter style={{ opacity: loading ? 0.3 : 1 }}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                count={equipments.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </Container>

    <ModalMassService modalMassService={modalMassService} closeModal={() => setModalMassService(false)} equipments={selectedEquipmentsObj} />
  </>;

}

const styles = {
  table: {
    position: 'relative',
    marginBottom: 50,
  },
  tableRow: {
    cursor: 'pointer'
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
  noResults: {
    height: '100px',
  },
  deleteTextConfirm: {
    marginLeft: '-30px',
    fontWeight: 'bold',
  },
  editWidth: {
    width: '90%'
  },
  avatar: {
    width: '2.75rem',
    height: '2.75rem',
    marginLeft: '0.25rem',
  },
  avatarSmallText: {
    fontSize: '0.75rem',
    width: '2.75rem',
    height: '2.75rem',
    marginLeft: '0.25rem',
  },
  chip: {
    margin: 5,
  },
  thumbUp: {
    marginRight: '20px',
    color: "#349c34"
  },
  thumbDown: {
    marginRight: '20px',
    color: "#d04545"
  },
  cell: {
    fontSize: '0.775rem',
    padding: '0.25rem',
  },
  cellPhotoContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: '0.5rem',
  },
  buttonFilterContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0px 20px 10px 20px',
  },
  buttonFilterIcon: {
    marginLeft: 5
  },
  buttonFilter: {
    zIndex: 200,
    backgroundColor: 'green',
    height: '2.2rem',
    width: '6.5rem',
    padding: '1rem',
    color: '#fff',
  },
  clearFilter: {
    cursor: 'pointer',
    textDecoration: 'underline',
    zIndex: 200,
    padding: '0.75rem 0.5rem',
    color: '#000',
  },
  filterContainer: {
    position: 'relative',
    width: '100%',
  },
  filterChipContainer: {
    paddingLeft: 20,
    display: 'flex',
    flexWrap: 'wrap',
  },
  filterChip: {
    cursor: 'pointer',
    margin: 5,
  },
  equipmentName: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '0.75rem',
  },
	status: {
		marginRight: '0.25rem'
	}
}



